module.exports = __webpack_public_path__ + "static/854725372-wide.b16e9285.jpg";